import { HotKey, Category } from '../types';
import { DEFAULT_HOTQUU_TILE_COLOR } from '../constants/hotQuuTheme';

/** Match each hot key to the station category list by id or name and copy API color (and metadata). */
export function applyCategoryColorsToHotKeys(hotKeys: HotKey[], categories: Category[]): HotKey[] {
  const miscFallback: Category = {
    id: 'Misc',
    name: 'Misc',
    color: DEFAULT_HOTQUU_TILE_COLOR,
    isPrivate: false,
    isDefault: true,
  };

  if (!categories?.length) {
    return hotKeys.map((hk) => ({
      ...hk,
      tileColor: hk.tileColor || DEFAULT_HOTQUU_TILE_COLOR,
      category: {
        ...hk.category,
        color: hk.category?.color && hk.category.color !== '#666666'
          ? hk.category.color
          : DEFAULT_HOTQUU_TILE_COLOR,
      },
    }));
  }

  const byId = new Map<string, Category>();
  const byName = new Map<string, Category>();
  for (const c of categories) {
    byId.set(String(c.id).trim().toLowerCase(), c);
    byName.set(String(c.name).trim().toLowerCase(), c);
  }

  return hotKeys.map((hk) => {
    const idKey = String(hk.categoryId).trim().toLowerCase();
    const nameKey = String(hk.category?.name ?? '').trim().toLowerCase();
    const cat = byId.get(idKey) ?? byName.get(nameKey) ?? byName.get(idKey);
    if (!cat) {
      const noCat = !idKey || idKey === 'misc' || idKey === 'undefined' || idKey === 'null';
      return {
        ...hk,
        tileColor: hk.tileColor || DEFAULT_HOTQUU_TILE_COLOR,
        category: noCat
          ? { ...miscFallback, ...hk.category, color: DEFAULT_HOTQUU_TILE_COLOR }
          : hk.category,
      };
    }

    return {
      ...hk,
      categoryId: String(cat.id),
      category: {
        ...hk.category,
        id: String(cat.id),
        name: cat.name,
        color: cat.color,
        isPrivate: cat.isPrivate,
        isDefault: cat.isDefault,
      },
    };
  });
}
